// extracted by mini-css-extract-plugin
module.exports = {"row":"row-2Dghm","price_wrapper":"price_wrapper-Xy-zP","price_block__delimiter":"price_block__delimiter-3VVfW","clear":"clear-12akA"};